import { resolveValue } from '@intlify/core-base'
import type { Composer, MessageResolver } from '#i18n'
import type { ComponentInternalInstance } from 'vue'
import type { MessageSchema } from './schema'

export const buildPrefix = (path: string) =>
  path.split('/app/')[1]?.split('.vue')[0]?.replace(/\//g, '.')

export const getI18nPrefix = (componentInfo: unknown) => {
  const { __i18n } = (componentInfo as { __i18n: { __prefix__: string } }) ?? {}
  return __i18n?.__prefix__ ?? null
}

export const messageGuard = (i18n: Composer) => {
  if (['fr', 'en'].includes(i18n.locale.value)) return true
  if (!(i18n.locale.value in i18n.messages.value)) return true
  return false
}

export const messageResolver: (
  i18n: Composer,
  instance: ComponentInternalInstance | null,
) => MessageResolver | undefined = (i18n, instance) => {
  if (messageGuard(i18n)) return
  const messages = (i18n.messages.value as MessageSchema)[i18n.locale.value]
  const prefixName = getI18nPrefix(instance?.type)
  if (!messages || !prefixName) return

  return (obj: unknown, path: string) => {
    if (typeof obj !== 'object' || obj === null) return null
    const oValue = resolveValue(obj, path)
    const flatKey = `${prefixName}.${path}`

    return (
      oValue ??
      messages[flatKey as keyof typeof messages] ??
      resolveValue(messages, flatKey)
    )
  }
}
